import {CALL_API} from 'redux-api-middleware';
import {
  API_HISTORY_GET_REQUEST,
  API_HISTORY_GET_SUCCESS,
  API_HISTORY_GET_FAILURE,
} from 'common/types';
import {ENDPOINT_HISTORY} from 'common/endpoints';
import {commonJwtHeader} from 'common/utils';

export default {
  getActivityHistoryByGrantId: (token, grantNumber, page) => {
    let pageQuery = page !== 0 ? `&page=${page}` : '';
    return {
      [CALL_API]: {
        endpoint: `${ENDPOINT_HISTORY}?awardNumber=${grantNumber}${pageQuery}`,
        headers: commonJwtHeader(),
        method: 'GET',
        types: [
          API_HISTORY_GET_REQUEST,
          API_HISTORY_GET_SUCCESS,
          API_HISTORY_GET_FAILURE,
        ],
      },
    };
  },
};
